import styled, { css } from "styled-components/macro";

import { DefaultFont } from "../../../styles/fonts";

export const Root = styled.div`
  margin: 16px 16px 40px;

  display: flex;
  justify-content: center;

  position: relative;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 800px;
`;
export const Sections = styled.div<{ $isProfileViewOnly?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 40px;

  .ant-form-item-label {
    font-weight: 500;
  }

  ${({ $isProfileViewOnly }) =>
    $isProfileViewOnly &&
    css`
      .ant-form-item-label {
        padding: 0;
      }
    `}
`;

export const SectionContainer = styled.div`
  padding: 32px;
  border: 1px solid #dcd6ce;
  border-radius: 4px;
  overflow-wrap: break-word;
`;
export const SectionTitle = styled.div`
  ${DefaultFont};
  font-size: 24px;
  color: ${(p) => p.theme.colors.hardGray};
`;
export const SectionHeader = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
`;
export const PageTitle = styled(SectionTitle)``;
export const Footer = styled.div`
  margin-top: 40px;
`;
export const FooterButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;

  @media (max-width: 460px) {
    flex-direction: column;
  }
`;
